export const makeI18nFallback = (defaultLng: string) => ({
    'zh-tw': ['zh-cht', defaultLng],
    'zh-hk': ['zh-cht', defaultLng],
    default: [defaultLng],
});
